import { Card, Table, Input, Button, message } from 'antd';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { $ } from '../../lib/api';

export function AdminSystemConfigsPage() {
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({ queryKey: ['system-configs'], queryFn: () => $.get<any[]>('/admin/system-configs') });
  const [editing, setEditing] = useState<Record<string, any>>({});
  const save = useMutation({
    mutationFn: ({ key, value }: any) => $.patch(`/admin/system-configs/${key}`, { value }),
    onSuccess: () => { message.success('已保存'); qc.invalidateQueries({ queryKey: ['system-configs'] }); },
  });
  return (
    <Card title="系统配置">
      <Table
        rowKey="id"
        loading={isLoading}
        dataSource={data ?? []}
        pagination={false}
        columns={[
          { title: 'Key', dataIndex: 'configKey', width: 280 },
          { title: '描述', dataIndex: 'description' },
          { title: '值', render: (_: any, r: any) =>
            <Input
              defaultValue={r.configValue}
              onChange={(e) => setEditing({ ...editing, [r.configKey]: e.target.value })}
              style={{ width: 200 }}
            /> },
          { title: '类型', dataIndex: 'configType' },
          { title: '操作', render: (_: any, r: any) =>
            <Button size="small" onClick={() => save.mutate({ key: r.configKey, value: editing[r.configKey] })}>保存</Button>
          },
        ]}
      />
    </Card>
  );
}
